import React, {Component} from "react";
import MediaQuery from 'react-responsive';
import device from '../../modules/mediaQuery'
import {connect} from 'react-redux';
import {NavbarBrand} from 'reactstrap';
import goback from '../../images/left-arrow-head.svg';
import MarketSearch from '../Common/MarketSearch';
import {withRouter} from 'react-router-dom'
import {Row, Col} from 'reactstrap';


class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            citiesList: null,
            sectorText: '',
            position: '',
            sectorColor: '',
            isShowSearchContainer: true
        };
        this.goBack = this.goBack.bind(this);
    }

    getMarkets() {
        let sortedMarkets = [];
        this.props.markets.forEach(element => {
            if (element.market.length > 0) {
                sortedMarkets.push(element.market);
            }
        });

        return sortedMarkets.sort();
    }

    onSearchClick = (isShowSearchContainer) => {
        this.setState({
            isShowSearchContainer
        });
    }


    goBack() {
     //   this.props.history.goBack();
     this.props.history.push(this.props.basepath);
        // Moved all the redux cleanup to MarketDetail.js componentwillUnMount method
    }

    render() {
        return (
            <Row className="main-rowheader">
                <Col className="text-left">
                    <NavbarBrand>
                        <img className="go-back-detail-page cursor-pointer" src={'#{rentrackerappimages}#' + '/left-arrow-head.svg'} onClick={this.goBack}
                             alt="goBack"/>
                        <span className="Market-Rent-Cycle-De">  Market Rent Details</span>
                    </NavbarBrand>

                </Col>
                <>

                    <MediaQuery query={device.min.desktop}>
                        <Col className="text-right" style={{display: "flex", justifyContent: "flex-end"}}>
                            <MarketSearch devicetype="desktop" marketSuggestions={this.getMarkets()}
                                          searchClickHandler={this.onSearchClick}/>
                        </Col>
                    </MediaQuery>
                </>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        markets: state.markets,
        selectedWheelPosition: state.selectedWheelPosition.selectedWheelPosition,
        selectedSliderPosition: state.selected,
        basepath: state.basepath,
        activePeriod: state.activePeriod
    };
};

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Header)
)